import StService from './StService';
import { createApi } from '@stilingue/st-auth-utils';
import gateway from './Gateway';
import { featureFlagFlags } from '@/plugins/rollout';
import { isProdVersion } from '@stilingue/st-environment-controller-utils';
import Vue from 'vue';

const version = isProdVersion()
  ? featureFlagFlags.AuthServiceVersionProd.getValue()
  : featureFlagFlags.AuthServiceVersionStaging.getValue();

const afterParser = response => response.data;

const HTTP_ERROR_MESSAGES = {
  400: 'Requisição inválida.',
  403: 'Acesso negado.',
  404: 'Recurso não encontrado.',
  500: 'Erro interno do servidor.',
  502: 'Serviço indisponível.',
  503: 'Serviço indisponível.',
};

function showErrorAndReject(status) {
  return (error) => {
    const msg = HTTP_ERROR_MESSAGES[status] || `Erro inesperado (${status}).`;
    Vue.prototype.$noty.error(msg);
    return Promise.reject(error);
  };
}

const errorStatusInterceptors = [400, 403, 404, 500, 502, 503].reduce((acc, status) => {
  acc[status] = showErrorAndReject(status);
  return acc;
}, {});

export class SocialProfilesService extends StService {
  constructor(basePath) {
    const api = createApi(`admin-tools/${version}/`, gateway, {
      timeout: 120000,
      errorStatusInterceptors,
    });
    super(api, { afterParser });
    this._basePath = basePath;
  }

  getProfiles({ page = 0, size = 100, search, sortBy, sortOrder } = {}) {
    const params = { page, size };
    if (search && search.length >= 3) {
      params.search = search;
    }
    if (sortBy) {
      params.sortBy = sortBy;
    }
    if (sortOrder) {
      params.sortOrder = sortOrder;
    }
    return this.find({ url: this._basePath, params });
  }

  deleteProfiles(ids = []) {
    return this.remove({ url: this._basePath, data: { ids } });
  }

  createProfile({ id, username }) {
    return this.update({ url: this._basePath, id, username });
  }

  createBatch(entries = []) {
    return this.update({ url: `${this._basePath}/batch`, entries });
  }
}
